import NotificationCard from './NotificationCard.component';

export default NotificationCard;
